import z from 'zod';

export const MessageCategorySchema = z.enum(['Activity', 'Marketing']);

export const MessageTypeSchema = z.enum([
  'Cash',
  'Bonus',
  'Coins',
  'CommunityJackpot',
  'DailyGift',
  'Free Spins',
  'InstantWheel',
  'Level',
  'LadderProgress',
]);

export const CtaTypeSchema = z.enum([
  'RedeemLoyaltyReward',
  'RedeemCommunityEventReward',
  'NavigationShop',
  'NavigationRewards',
  'NavigationGames',
  'NavigationPromotions',
]);

export const CtaSchema = z.object({
  type: CtaTypeSchema,
  text: z.string(),
});

export const InboxMessageResponseSchema = z.object({
  id: z.number(),
  category: MessageCategorySchema,
  type: MessageTypeSchema.optional(),
  isRead: z.boolean(),
  cta: CtaSchema,
  createdAt: z.string().datetime(),
  title: z.string(),
  body: z.string(),
});

export const InboxResponseSchema = z.array(InboxMessageResponseSchema);
